import { TreeRuleConfiguration } from "../../../rule-engine-core/Rule/Tree/TreeRuleConfiguration";

export const getEmptyRuleDefinition = () => {
    return new TreeRuleConfiguration();
};
